import React from "react";
import styles from "./TeamModalContent.module.scss";
import { TeamCardElementType } from "../TeamCard/TeamCard";
import { customSanitize } from "@/utils/customSanitize";
import { hasParagraphTag } from "@/utils/hasParagraphTag";
import { Socials } from "./Socials/Socials";
import { OptionsSocialMediaType } from "@/types/OptionType";
import { useModal } from "../_primitives/Modal/ModalRoot/ModalRoot";
import { HeadersOptionsType } from "@/types/ModuleOptionsType";
import { MediaItem } from "../MediaItem/MediaItem";

interface TeamModalContentProps {
  team: TeamCardElementType;
  socialMedia: OptionsSocialMediaType;
  teamheaderOptions: HeadersOptionsType["header_team"];
}

export const TeamModalContent = ({
  team,
  socialMedia,
  teamheaderOptions,
}: TeamModalContentProps) => {
  const { setOpen } = useModal();
  const { element } = team;
  const show = teamheaderOptions?.show;
  return (
    <div className={`${styles["team-modal-content"]} section`}>
      <div className="container">
        {/* eslint-disable-next-line jsx-a11y/no-static-element-interactions */}
        <div
          className="columns is-centered"
          onClick={(e) => {
            if (e.target === e.currentTarget) {
              setOpen(false);
            }
          }}
          onKeyDown={(e) => {
            if (e.key === "Escape") {
              setOpen(false);
            }
          }}
        >
          <div
            className={`column is-12-mobile is-10-tablet is-8-widescreen is-6-ultrahd is-relative has-hellgrau-bg`}
          >
            <div className="columns is-multiline p-4 is-vcentered">
              <div className="column is-6-tablet">
                <MediaItem
                  image_desktop={element.image}
                  mediaFormat={{
                    mobile: "square",
                    desktop: "square",
                    fullhd: "square",
                    tablet: "square",
                  }}
                  sizes="(max-width: 768px) 100vw, (max-width: 1024px) 50vw, 33vw"
                  copyrightPosition={"bottom"}
                  showMediaInfo={false}
                />
              </div>
              <div
                className={`column is-6-tablet ${styles["team-modal-address"]}`}
              >
                <div className="mb-5">
                  {(show?.includes("name") || show?.includes("firstname")) && (
                    <span className={styles["name"]}>
                      {show.includes("firstname") ? element.firstname : ""}
                      {show.includes("firstname") &&
                      show.includes("name") &&
                      element.firstname
                        ? " "
                        : ""}
                      {show.includes("name") ? element.name : ""}
                    </span>
                  )}
                  {show?.includes("salutation") && (
                    <span className={styles["salutation"]}>
                      {element.salutation}
                    </span>
                  )}
                </div>

                <address>
                  {show?.includes("position") && (
                    <span>{element.position}</span>
                  )}
                  {show?.includes("company_location") && (
                    <span>{element.company_location}</span>
                  )}
                  {show?.includes("phone") && element.phone && (
                    <span>Tel: {element.phone}</span>
                  )}
                  {show?.includes("mobile_phone") && element.mobile_phone && (
                    <span>Mobil: {element.mobile_phone}</span>
                  )}
                  {show?.includes("email") && element.email && (
                    <span>E-Mail: {element.email}</span>
                  )}
                </address>

                {show?.includes("socials") && (
                  <Socials
                    socials={element.socials}
                    socialMedia={socialMedia}
                  />
                )}
              </div>
              {element.content && (
                <div className="column is-12">
                  {hasParagraphTag(element.content) ? (
                    <div
                      dangerouslySetInnerHTML={{
                        __html: customSanitize(element.content),
                      }}
                    />
                  ) : (
                    <p>{element.content}</p>
                  )}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
